import { render, staticRenderFns } from "./CustomDotAlert.vue?vue&type=template&id=3983d074&scoped=true&"
import script from "./CustomDotAlert.vue?vue&type=script&lang=js&"
export * from "./CustomDotAlert.vue?vue&type=script&lang=js&"
import style0 from "./CustomDotAlert.vue?vue&type=style&index=0&id=3983d074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983d074",
  null
  
)

export default component.exports